module.exports = __webpack_public_path__ + "img/product8.d8e753cd.png";